const pythonReasons = [
    {
        id: "python-reason-1",
        title: "Python is Growing Faster Than Any Other Language",
        description: (
            <>
                According to Stack Overflow and GitHub, Python has seen{" "}
                <span className="highlight">
                    year-over-year growth
                </span>{" "}
                in developer adoption — making it a{" "}
                <span className="highlight-blue">
                    future-proof choice
                </span>{" "}
                for your career.
            </>
        ),
    },

    {
        id: "python-reason-2",
        title: "Python is a Most In-Demand Skill Across Tech Roles",
        description: (
            <>
                Python is a{" "}
                <span className="highlight-blue">
                    top requirement
                </span>{" "}
                for roles like:
            </>
        ),
        roles: [
            "Data Scientist",
            "Machine Learning Engineer",
            "AI Developer",
            "Python Developer",
            "Automation Tester",
            "Web Developer",
            "DevOps Engineer",
        ],
    },

    {
        id: "python-reason-3",
        title: "Python Unlocks High-Paying Jobs",
        description: (
            <>
                Python developers can access a wide range of career
                opportunities. In India, entry-level roles are often
                advertised around{" "}
                <span className="highlight">
                    ₹4–6 LPA
                </span>
                , while experienced professionals in AI/Data Science may
                reach{" "}
                <span className="highlight">
                    ₹20–50+ LPA
                </span>{" "}
                depending on experience, company, and specialization.
            </>
        ),
    },

    {
        id: "python-reason-4",
        title: "Global Job Market is Booming",
        description: (
            <>
                Python-related skills are used across industries including{" "}
                <span className="highlight-blue">
                    fintech, healthcare, education, e-commerce
                </span>{" "}
                and many others.
            </>
        ),
    },

    {
        id: "python-reason-5",
        title: "Python is a Leading Language for AI & Data Science",
        description: (
            <>
                Python is widely used for{" "}
                <span className="highlight">
                    AI, Machine Learning and Data Science
                </span>{" "}
                because of powerful libraries and frameworks such as:
            </>
        ),
        tags: [
            "NumPy",
            "Pandas",
            "TensorFlow",
            "Scikit-learn",
        ],
    },

    {
        id: "python-reason-6",
        title: "Easy to Learn, Yet Super Powerful",
        description: (
            <>
                Python has a{" "}
                <span className="highlight">
                    simple and readable syntax
                </span>
                , making it approachable for beginners while still being
                powerful enough to build complex applications.
            </>
        ),
    },

    {
        id: "python-reason-7",
        title: "Massive Ecosystem: Build Almost Anything",
        description: (
            <>
                From web applications using{" "}
                <span className="tech-tag">
                    Django
                </span>{" "}
                or{" "}
                <span className="tech-tag">
                    Flask
                </span>{" "}
                to automation, data processing and games, Python provides a{" "}
                <span className="highlight-blue">
                    massive ecosystem of tools and libraries
                </span>
                .
            </>
        ),
    },

    {
        id: "python-reason-8",
        title: "Abundant Learning Resources and Community",
        description: (
            <>
                Python has a huge collection of{" "}
                <span className="highlight">
                    tutorials, documentation, open-source projects
                </span>{" "}
                and community resources, making it easier to continue
                learning throughout your career.
            </>
        ),
    },

    {
        id: "python-reason-9",
        title: "Used by Major Technology Organizations",
        description: (
            <>
                Python is used by organizations such as{" "}
                <span className="highlight-blue">
                    Google, Meta, Amazon, Spotify, Netflix and Microsoft
                </span>{" "}
                for areas including backend development, automation, data
                analysis and AI.
            </>
        ),
    },

    {
        id: "python-reason-10",
        title: "Great for Freelancing & Side Projects",
        description: (
            <>
                Python skills can be applied to freelance and independent
                projects such as{" "}
                <span className="highlight">
                    automation, web scraping, API development and data
                    analysis
                </span>
                .
            </>
        ),
    },
];

export default pythonReasons;